import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { comprasRecientes } from '../data/notifications';
const FIRST_DELAY = 6000;
const INTERVAL = 15000;
const VISIBLE = 5500;
const iniciales = (nombre: string): string => nombre.split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % comprasRecientes.length);
          cycle(INTERVAL - VISIBLE);
        }, VISIBLE);
      }, delay);
    };
    cycle(FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const compra = comprasRecientes[index];
  const ciudad = compra.ciudad.split(',')[0];
  return <div aria-live="polite" className="pointer-events-none fixed inset-x-3 bottom-3 z-50 flex justify-center sm:inset-x-auto sm:bottom-5 sm:left-5 sm:justify-start" data-id="element-131" data-mp="evp0k47kzr8p">
      <AnimatePresence mode="wait" data-id="element-132" data-mp="17k32gv1sj7pj">
        {visible && <motion.div key={`${compra.nombre}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.98
      }} transition={{
        type: 'spring',
        stiffness: 420,
        damping: 30,
        mass: 0.6
      }} className="pointer-events-auto flex w-full max-w-[330px] items-center gap-2.5 overflow-hidden rounded-xl border border-surface-line bg-white/95 py-2 pl-2 pr-1.5 shadow-lift backdrop-blur" data-id="element-133" data-mp="17km8bde625n7">
            <span className="w-1 self-stretch rounded-full bg-brand" aria-hidden="true" data-id="element-134" data-mp="3koyczo3rh9us" />

            <span className="relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-soft text-[11px] font-extrabold text-brand-dark" data-id="element-135" data-mp="3pnt217sbnunc">
              {iniciales(compra.nombre)}
              <span className="absolute -bottom-0.5 -right-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-success ring-2 ring-white" data-id="element-136" data-mp="3ftj0azhhpjzy">
                <CheckIcon className="h-2 w-2 text-white" strokeWidth={4} aria-hidden="true" data-id="element-137" data-mp="36s2znjgh8w8x" />
              </span>
            </span>

            <div className="min-w-0 flex-1" data-id="element-138" data-mp="2s3yco3ae5ykc">
              <p className="truncate text-[12px] leading-tight text-ink" data-id="element-139" data-mp="2x0ovuzhhta9z">
                <span className="font-bold text-ink-strong" data-id="element-140" data-mp="2j1fe3vdn283w">{compra.nombre}</span>{' '}
                acaba de comprar el sistema
              </p>
              <p className="mt-0.5 flex items-center gap-1.5 text-[10px] font-semibold text-ink-muted" data-id="element-141" data-mp="2n1qxz5y6g4eb">
                <motion.span animate={{
              opacity: [1, 0.25, 1]
            }} transition={{
              duration: 1.8,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="h-1.5 w-1.5 rounded-full bg-success" aria-hidden="true" data-id="element-142" data-mp="24fjgoh7ehw9b" />
                {ciudad} · hace {compra.minutos} min
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones" className="flex h-6 w-6 shrink-0 items-center justify-center self-start rounded-full text-ink-muted transition-colors duration-150 ease-out hover:bg-surface-alt hover:text-ink-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand" data-id="element-143" data-mp="2ncszbw4wj5pi">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-144" data-mp="3150ujjgjeom3" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}